export const DASHBOARD_ROUTE = 'DASHBOARD_ROUTE';
export const LOGIN_ROUTE = 'LOGIN_ROUTE';
export const SIGNUP_PROFILE_ROUTE = 'SIGNUP_PROFILE_ROUTE';
export const SIGNUP_ORGANIZATION_ROUTE = 'SIGNUP_ORGANIZATION_ROUTE';
export const FORGOT_PASSWORD_ROUTE = 'FORGOT_PASSWORD_ROUTE';
export const SET_PASSWORD_ROUTE = 'SET_PASSWORD_ROUTE';
export const RESET_PASSWORD_ROUTE = 'RESET_PASSWORD_ROUTE';
export const VERIFY_EMAIL_ROUTE = 'VERIFY_EMAIL_ROUTE';
export const EMAIL_VERIFICATION_WALL_ROUTE = 'EMAIL_VERIFICATION_WALL_ROUTE';
export const ANNOUNCEMENTS_ROUTE = 'ANNOUNCEMENTS_ROUTE';
export const ADD_ANNOUNCEMENT_ROUTE = 'ADD_ANNOUNCEMENT_ROUTE';
export const EDIT_ANNOUNCEMENT_ROUTE = 'EDIT_ANNOUNCEMENT_ROUTE';
export const DUPLICATE_ANNOUNCEMENT_ROUTE = 'DUPLICATE_ANNOUNCEMENT_ROUTE';
export const ADD_SHIUREI_TORAH_ROUTE = 'ADD_SHIUREI_TORAH_ROUTE';
export const EDIT_SHIUREI_TORAH_ROUTE = 'EDIT_SHIUREI_TORAH_ROUTE';
export const DUPLICATE_SHIUREI_TORAH_ROUTE = 'DUPLICATE_SHIUREI_TORAH_ROUTE';
export const DONATIONS_ROUTE = 'DONATIONS_ROUTE';
export const ADD_DONATION_ROUTE = 'ADD_DONATION_ROUTE';
export const MEMBERS_ROUTE = 'MEMBERS_ROUTE';
export const MINYUNIM_ROUTE = 'MINYUNIM_ROUTE';
export const ZMANIM_ROUTE = 'ZMANIM_ROUTE';
export const EMAIL_ROUTE = 'EMAIL_ROUTE';
export const TEXTS_ROUTE = 'TEXTS_ROUTE';
export const ADD_TEMPLATE_ROUTE = 'ADD_TEMPLATE_ROUTE';
export const EVENTS_ROUTE = 'EVENTS_ROUTE';
export const POSTERS_ROUTE = 'POSTERS_ROUTE';
export const TICKETS_ROUTE = 'TICKETS_ROUTE';
export const DATE_TIME_BANNER_ROUTE = 'DATE_TIME_BANNER_ROUTE';
export const API_KEYS_ROUTE = 'API_KEYS_ROUTE';
export const SETTINGS_ROUTE = 'SETTINGS_ROUTE';
export const MINYANIM_COUNTDOWN_ROUTE = 'MINYANIM_COUNTDOWN_ROUTE';
export const MINYANIM_N_ROUTE = 'MINYANIM_N_ROUTE';
export const MINYANIM_ROLLS_N_ROUTE = 'MINYANIM_ROLLS_N_ROUTE';
export const ADD_MINYANIM_ROLL_N_ROUTE = 'ADD_MINYANIM_ROLL_N_ROUTE';
export const EDIT_MINYANIM_ROLL_N_ROUTE = 'EDIT_MINYANIM_ROLL_N_ROUTE';
export const DUPLICATE_MINYANIM_ROLL_N_ROUTE = 'DUPLICATE_MINYANIM_ROLL_N_ROUTE';
export const ZMANIM_N_ROUTE = 'ZMANIM_N_ROUTE';
export const ADD_ZMANIM_N_ROUTE = 'ADD_ZMANIM_N_ROUTE';
export const EDIT_ZMANIM_N_ROUTE = 'EDIT_ZMANIM_N_ROUTE';
export const DUPLICATE_ZMANIM_N_ROUTE = 'DUPLICATE_ZMANIM_N_ROUTE';
export const DONATIONS_N_ROUTE = 'DONATIONS_N_ROUTE';
export const ANNOUNCEMENTS_N_ROUTE = 'ANNOUNCEMENTS_N_ROUTE';
export const SHIUREI_TORAH_N_ROUTE = 'SHIUREI_TORAH_N_ROUTE';
export const KABBALAH_N_ROUTE = 'KABBALAH_N_ROUTE';
export const KABBALAH_PUBLIC_FORM_ROUTE = 'KABBALAH_PUBLIC_FORM_ROUTE';
export const KABBALAH_PUBLIC_FORM_LEGACY_ROUTE = 'KABBALAH_PUBLIC_FORM_LEGACY_ROUTE';

export const DISPLAY_ROUTE = 'DISPLAY_ROUTE';
// The switching link: plays a screen schedule's member screens on its timetable.
export const SCREEN_SCHEDULE_DISPLAY_ROUTE = 'SCREEN_SCHEDULE_DISPLAY_ROUTE';

export const DOCS_HOME_ROUTE = 'DOCS_HOME_ROUTE';
export const DOCS_AUTHENTICATION_ROUTE = 'DOCS_AUTHENTICATION_ROUTE';
export const DOCS_SCREEN_ROUTE = 'DOCS_SCREEN_ROUTE';
export const DOCS_TEMPLATE_ROUTE = 'DOCS_TEMPLATE_ROUTE';
export const DOCS_DONATION_ROUTE = 'DOCS_DONATION_ROUTE';
export const DOCS_ANNOUNCEMENT_ROUTE = 'DOCS_ANNOUNCEMENT_ROUTE';
export const DOCS_KABBALAH_ROUTE = 'DOCS_KABBALAH_ROUTE';

export const RICH_TEXT_EDITOR_TEST_ROUTE = 'TEXT_EDITOR_TEST_ROUTE';

export const ERROR_ROUTE = 'ERROR_ROUTE';
export const NOT_FOUND_404_ROUTE = 'NOT_FOUND_404_ROUTE';

// The Screenkode admin's way in for a support session (utils/support_session).
export const SUPPORT_SESSION_ROUTE = 'SUPPORT_SESSION_ROUTE';
